var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.287 18.1808L33.4046 26.912L18.0081 34L15.9813 34L0.416717 27.0328L0.416715 6.96719L15.9813 5.33895e-06L18.0039 5.16213e-06L33.2697 6.97103L33.4167 18.1808L33.287 18.1808ZM30.7134 15.4794L30.6248 8.7266L17.4302 2.70138L16.5447 2.70139L3.08441 8.7266L3.08441 15.4794L12.7787 15.4794L14.0656 11.8264L17.1543 11.8264L13.7353 22.3957L10.7196 22.3898L12.0065 18.6105L3.08441 18.6105L3.08441 25.2734L16.5447 31.2986L17.4302 31.2986L30.7134 25.1835L30.6248 18.6105L20.5004 18.6105L19.2899 22.3898L15.8674 22.3957L19.2899 11.7842L22.5595 11.7842L21.53 15.4794L30.7134 15.4794Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logoDark.e56d54a709171eb20fdfdeb7aa9305dc.svg";
export { ForwardRef as ReactComponent };